import { Component, Input, OnInit } from '@angular/core';
import { CardholderListItem } from '@app-model/cardholder';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-cardholder-info',
	templateUrl: './cardholder-info.component.html',
	styleUrls: ['./cardholder-info.component.scss']
})
export class CardholderInfoComponent implements OnInit {
	@Input() cardholder?: CardholderInfoLike;

	constructor(public translate: TranslateService) {}

	ngOnInit(): void {}
}

export interface CardholderInfoLike extends Omit<Partial<CardholderListItem>, 'client' | 'group'> {
	name?: string;
	canonicalURL?: string;
	pictureUrl?: string;
	client?: { id?: string; name?: string } | null;
	group?: { id?: string; name?: string } | null;
}
